"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroSlideContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _slideContent = require("../../components/slide-content/slide-content");

var _heroSlideContent = require("./hero-slide-content.styled");

var _const = require("../../../../const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroSlideContent = function HeroSlideContent(_ref) {
  var line1 = _ref.headlineOneText,
      line2 = _ref.headlineTwoText,
      line3 = _ref.description,
      buttons = _ref.buttons,
      type = _ref.type,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? _const.TextAlignment.CENTER : _ref$textAlign,
      textColor = _ref.textColor,
      textBackgroundColor = _ref.textBackgroundColor,
      logoLayout = _ref.logoLayout,
      logoFileReference = _ref.logoFileReference,
      logoAltText = _ref.logoAltText;
  return /*#__PURE__*/_react.default.createElement(_heroSlideContent.HeroSlideContentStyled, {
    type: type,
    textAlign: textAlign,
    textColor: textColor,
    textBackgroundColor: textBackgroundColor
  }, /*#__PURE__*/_react.default.createElement(_heroSlideContent.HeroSlideContentWrapper, null, /*#__PURE__*/_react.default.createElement(_slideContent.SlideContent, {
    line1: line1,
    line2: line2,
    line3: line3,
    buttons: buttons,
    bg: textBackgroundColor,
    logoLayout: logoLayout,
    logoFileReference: logoFileReference,
    logoAltText: logoAltText
  })));
};

exports.HeroSlideContent = HeroSlideContent;